import React, { useEffect, useState } from 'react';
import Loader from "../../components/Loader"; 
import Paginator from "../../components/Paginator"; 
import ApiService from "../../services/ApiService";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { Link  } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const List = () => {
    
    const [isLoader, setIsLoader] = useState(false);
    const [payments, setPayments] = useState([]);
    const [pagination, setPagination] = useState({});
    const [currency] = useState(process.env.REACT_APP_CURRENCY);
    
    const [apiData, setApiData] = useState({
        search: "",
        daterange: "",
        page: 0,
    });
 
    
    useEffect(() => {
        getpayments();
    }, [apiData.page, apiData.search, apiData.daterange]); // Dependency array for re-fetching data

    const getpayments = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: "GET",
                url: "payments", // Replace with your API endpoint
                data: apiData
            });
            const data = response.data;
            if (data.status) {
                setPayments(data.data);
                setPagination(data.pagination);
            } else {
                toast.error(data.message);
            }
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
        }
       
    };

    const handlePageChange = (event) => {
        setApiData(prev => ({ ...prev, page: event }));
    };

    const clearFilter = () => {
        setApiData({
            search: '',
            daterange: '',
            page: 0
        });
    };


 


    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">{("Payments")}</h1>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <li className="breadcrumb-item text-muted">
                                <Link to="/dashboard" className="text-muted text-hover-primary">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <span className="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <li className="breadcrumb-item text-muted">{("Payments")}</li>
                        </ul>
                    </div>
                    <div className="d-flex align-payments-center gap-2 gap-lg-3">
                        {/* Add New payments Button */}
                    </div>
                </div>
            </div>
            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-xxl">
                    <div className="card">
                        <div className="card-header border-0 pt-6">
                            <div className="w-100">
                                <form method="get">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="d-flex align-payments-center position-relative my-1">
                                                <input type="text" value={apiData.search} onChange={e => setApiData({ ...apiData, search: e.target.value })} className="form-control form-control-solid me-5"
                                                 placeholder={("Search...")} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <DatePicker
                                                selectsRange={true}
                                                startDate={apiData.daterange[0]}
                                                endDate={apiData.daterange[1]}
                                                onChange={e => setApiData({ ...apiData, daterange: e })} 
                                                isClearable={true}
                                                className='form-control form-control-solid'
                                                placeholderText={('Select Daterange')}
                                            />
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <button type="button" onClick={clearFilter} className={`btn btn-sm btn-secondary mx-1 ${!apiData.search && !apiData.daterange ? 'd-none' : ''}`}>{('clear')}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div id="kt_payments_table_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                <div className="table-responsive">
                                    <table className="table align-middle table-hover fs-6 gy-5 dataTable no-footer">
                                        <thead>
                                            <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                <th>User</th>
                                                <th>Payment for</th>
                                                <th>Details</th>
                                                <th>Payment</th>
                                                <th>Transaction ID</th>
                                                <th>Status</th>
                                                <th>Date</th>
                                            </tr>
                                        </thead>
                                        <tbody className="fw-semibold text-gray-600 fs-6">
                                            {payments.length > 0 ? payments.map((cat, index) => (
                                                <tr key={index}>
                                                    <td> <img src={cat.user?.picture} alt="logo" className='w-50px h-50px rounded-circle mx-2' /> 
                                                    {cat.user?.username} 
                                                    </td>
                                                    <td className='text-capitalize'>{(cat.pay_for=='interview')?'course':cat.pay_for }</td>
                                                    <td> 
                                                    {cat.pay_for === 'subscription' &&
                                                        <span>
                                                        {cat.data["name"]} <br />
                                                         Duration: {cat.data["duration"]+" "+cat.data["duration_type"]}
                                                        </span>
                                                            
                                                    }
                                                    {cat.pay_for === 'interview' &&
                                                        <span className='text-center'>
                                                            {/* <img src={cat.data['thumbnail']} alt="thumbnail" className='w-50px h-50px rounded' />  */}
                                                            {cat.data["title"]} <br />
                                                            Duration: {cat.data["duration"]+" "+cat.data["duration_type"]}
                                                        </span>
                                                    }
                                                    </td>

                                                    <td>{currency} {cat.amount}</td>
                                                    <td>  {cat.transaction_id}   </td>
                                                    <td>  {cat.pay_status}   </td>
                                                    <td>{cat.created_at}</td>
                                                  
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan="11" className="text-dark text-center mt-2">No data found!!</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table> 
                                    {isLoader && (
                                        <Loader text="Loading" size="30" className="text-center"  />
                                    )}

                                    {pagination.total_pages > 1 && (
                                        <Paginator
                                            page={pagination.current_page}
                                            rows={pagination.per_page}
                                            totalRecords={pagination.total_records}
                                            onPageChange={handlePageChange}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default List;
